<template>
  <div>
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("headings.countries") }}</v-toolbar-title>
      <v-spacer> </v-spacer>
      <v-btn @click="handleOpenDialog" class="primary mx-2">
        <v-icon small left>mdi-plus</v-icon>
        <span>{{ $t("button.create") }}</span>
      </v-btn>
    </v-toolbar>
    <!-- table -->
    <wrapping-table
      ref="table_ref"
      :headersName="headers"
      pathName="countries"
      class="table-row"
      dialogWidth="500"
    >
      <template slot-scope="{ item, index }">
        <td class="text-sm-center">{{ item.name }}</td>
        <td class="text-sm-center">{{ item.code }}</td>
        <td class="text-sm-center">{{ item.phone_code }}</td>
        <td class="text-sm-center" v-if="item.flag !== null">
          <v-avatar size="30">
            <v-img :src="item.flag && item.flag.path" alt="image"></v-img>
          </v-avatar>
        </td>
        <td v-else class="text-sm-center">
          <v-icon>mdi-flag</v-icon>
        </td>
        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="countries"
            :model-id="item.id"
            field="visible"
            v-model="item.visible"
            :validate="true"
          />
        </td>
        <td class="text-sm-center">
          <v-btn
            :title="$t('icon.states')"
            icon
            :to="`/countries/${item.id}/states`"
          >
            <v-icon>mdi-earth</v-icon>
          </v-btn>
        </td>
        <td class="text-sm-center">
          <v-btn
            :title="$t('icon.cities')"
            icon
            :to="`/countries/${item.id}/cities`"
          >
            <v-icon>mdi-city</v-icon>
          </v-btn>
        </td>
        <td class="text-sm-center">
          <v-icon
            @click="handleEdit(item, index)"
            small
            :title="$t('icon.edit')"
            >mdi-pencil</v-icon
          >
          <v-icon
            @click="handleDelete(item, index)"
            small
            :title="$t('icon.delete')"
            >mdi-delete</v-icon
          >
        </td>
      </template>
      <!-- dilaog -->
      <template #wrraping_dialog="{ dialog }">
        <form-action
          :isEdit="isEdit"
          :dialog="dialog"
          :table_ref="$refs.table_ref"
          :item="item"
          :index="itemIndex"
          @update_main_image="updateImage"
          @dialog_close="isEdit = false"
        />
      </template>
      <!-- dilaog -->
    </wrapping-table>
    <!-- table -->
  </div>
</template>

<script>
export default {
  name: "Countries",
  components: {
    FormAction: () => import("./components/FormAction"),
  },

  data() {
    return {
      isEdit: false,
      itemIndex: "",
      item: {},
      headers: [
        "name",
        "code",
        "phone_code",
        "flag",
        "visible",
        "states",
        "cities",
        "actions",
      ],
    };
  },
  methods: {
    updateImage(photo) {
      this.$set(this.item, "flag", photo);
    },
    handleOpenDialog() {
      this.$refs.table_ref.toggleDialog();
    },
    handleDelete({ id }, index) {
      this.$refs.table_ref.handleDelete(id, index);
    },
    handleEdit(item, index) {
      this.isEdit = true;
      this.item = item;
      this.itemIndex = String(index);
      this.$refs.table_ref.toggleDialog();
    },
  },
};
</script>
